<template>
  <el-dialog
    :title="$t('deleteReportCustomComponentRel.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center>
    <div style="text-align: center;">
      <p>{{$t('deleteReportCustomComponentRel.confirmDelete')}}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteReportCustomComponentRelModel()">
        {{$t('deleteReportCustomComponentRel.cancel')}}
      </el-button>
      <el-button 
        type="primary" 
        @click="deleteReportCustomComponentRel()">
        {{$t('deleteReportCustomComponentRel.confirmDeleteBtn')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteReportCustomComponentRel } from '@/api/dev/reportCustomComponentRelApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteReportCustomComponentRel',
  data() {
    return {
      dialogVisible: false,
      deleteReportCustomComponentRelInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteReportCustomComponentRelInfo = {...params}
      this.dialogVisible = true
    },
    async deleteReportCustomComponentRel() {
      this.deleteReportCustomComponentRelInfo.shopId = getShopId()
      try {
        const res = await deleteReportCustomComponentRel(this.deleteReportCustomComponentRelInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('listReportCustomComponentRel')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error(error)
      }
    },
    closeDeleteReportCustomComponentRelModel() {
      this.dialogVisible = false
    }
  }
}
</script>